import { FC } from 'react';

type Props = {
	className?: string;
};

const Calendar_04_IconSolid: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='#2B2B2B'
			stroke='none'
			className={className}>
			<path
				d='M6.36473 2.72729C6.36473 2.32562 6.03911 2 5.63744 2C5.23578 2 4.91016 2.32562 4.91016 2.72729V3.05373C5.18676 2.96599 5.48147 2.90335 5.79405 2.85791C5.97438 2.8317 6.16452 2.81075 6.36473 2.794V2.72729Z'
				fill='inherit'
			/>
			<path
				d='M15.0913 3.05373C14.8147 2.96599 14.52 2.90335 14.2074 2.85791C14.0271 2.8317 13.8369 2.81075 13.6367 2.794V2.72729C13.6367 2.32562 13.9623 2 14.364 2C14.7657 2 15.0913 2.32562 15.0913 2.72729V3.05373Z'
				fill='inherit'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M10.748 2.72705H9.25155C7.83461 2.72703 6.69166 2.72701 5.79267 2.85768C4.85449 2.99404 4.07735 3.28547 3.46732 3.94496C2.86474 4.5964 2.60531 5.41271 2.48267 6.39887C2.36326 7.35909 2.36327 8.58468 2.36328 10.1264V10.6007C2.36327 12.1424 2.36326 13.368 2.48267 14.3282C2.60531 15.3144 2.86474 16.1307 3.46732 16.7821C4.07735 17.4416 4.85449 17.7331 5.79267 17.8694C6.69166 18.0001 7.8346 18.0001 9.25155 18.0001H10.748C12.165 18.0001 13.3079 18.0001 14.2069 17.8694C15.1451 17.7331 15.9222 17.4416 16.5323 16.7821C17.1348 16.1307 17.3942 15.3144 17.5169 14.3282C17.6363 13.368 17.6363 12.1424 17.6363 10.6007V10.1264C17.6363 8.58468 17.6363 7.3591 17.5169 6.39887C17.3942 5.41271 17.1348 4.5964 16.5323 3.94496C15.9222 3.28547 15.1451 2.99404 14.2069 2.85768C13.3079 2.72701 12.165 2.72703 10.748 2.72705ZM4.54356 7.81805C4.21001 7.81805 4.04324 7.81805 3.93702 7.9229C3.83081 8.02775 3.82867 8.1924 3.8244 8.52171C3.81805 9.01131 3.81785 9.55932 3.81785 10.1768V10.5503C3.81785 12.1538 3.81918 13.2888 3.92612 14.1487C4.03114 14.9932 4.22705 15.4614 4.53512 15.7944C4.83573 16.1194 5.24675 16.3202 6.00189 16.43C6.78415 16.5437 7.82101 16.5455 9.30886 16.5455H10.6907C12.1785 16.5455 13.2154 16.5437 13.9977 16.43C14.7528 16.3202 15.1638 16.1194 15.4645 15.7944C15.7725 15.4614 15.9684 14.9932 16.0734 14.1487C16.1804 13.2888 16.1817 12.1538 16.1817 10.5503V10.1768C16.1817 9.55932 16.1815 9.01131 16.1752 8.52171C16.1709 8.1924 16.1688 8.02775 16.0626 7.9229C15.9563 7.81805 15.7896 7.81805 15.456 7.81805H4.54356Z'
				fill='inherit'
				stroke='transparent'
			/>
		</svg>
	);
};

export default Calendar_04_IconSolid;
